import { CHILD_ABOUT_STEP } from "Components/Features/CheckPrice/Products/LifeProducts/Child";
import { JACKSON_MAGIC_DELETE_KEYWORD } from "Store/addProductToCart/productMappers";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";

export type ChildHealthProductBackend = {
  name: INSURANCE_NAME_VALUE;
  childFirstName: string;
  childLastName?: typeof JACKSON_MAGIC_DELETE_KEYWORD;
  childNin?: typeof JACKSON_MAGIC_DELETE_KEYWORD;
  relatedChildProductId: string;
};

export function mapToCommerceChildHealth(
  data: {
    [key: string]: any;
  },
  type: INSURANCE_NAME_VALUE.CHILD_HEALTH,
): ChildHealthProductBackend {
  const formValues = data.formData;
  const childFirstName: string = formValues[CHILD_ABOUT_STEP.id].childFirstName;
  const dateOfBirth = reverseAndPadDDMMYYYY(
    formValues[CHILD_ABOUT_STEP.id].childBirthDate,
  );

  const mappedChildHealthProduct = {
    name: type,
    coverageGroup: data.coverage,
    childDateOfBirth: dateOfBirth,
    relatedChildProductId: data.productId,
    childFirstName,
  };

  if (
    data.storedProduct &&
    data.storedProduct.childLastName &&
    childFirstName.localeCompare(data.storedProduct.childFirstName) !== 0
  ) {
    return {
      ...mappedChildHealthProduct,
      childFirstName,
      childLastName: JACKSON_MAGIC_DELETE_KEYWORD,
      childNin: JACKSON_MAGIC_DELETE_KEYWORD,
    };
  }
  return mappedChildHealthProduct;
}
